const StarSharpIcon = () => {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.53045 1.23682L7.84295 5.36182H11.9679L8.59295 7.98682L9.71795 12.1118L6.53045 9.48682L3.34295 12.1118L4.46795 7.98682L1.09295 5.36182H5.21795L6.53045 1.23682Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.75"
      />
    </svg>
  )
}

export default StarSharpIcon
